/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_carbs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carbs`)
};

const es_macro_carbs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carbohidratos`)
};

const de_macro_carbs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohlenhydrate`)
};

const nl_macro_carbs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koolhydraten`)
};

const fr_macro_carbs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glucides`)
};

const it_macro_carbs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carboidrati`)
};

const pt_br2_macro_carbs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carboidratos`)
};

const pt_macro_carbs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidratos`)
};

const ja_macro_carbs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`炭水化物`)
};

const zh_macro_carbs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`碳水`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_carbs = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_carbs(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_carbs", locale)
	if (locale === "en") return en_macro_carbs(inputs)
	if (locale === "es") return es_macro_carbs(inputs)
	if (locale === "de") return de_macro_carbs(inputs)
	if (locale === "nl") return nl_macro_carbs(inputs)
	if (locale === "fr") return fr_macro_carbs(inputs)
	if (locale === "it") return it_macro_carbs(inputs)
	if (locale === "pt-BR") return pt_br2_macro_carbs(inputs)
	if (locale === "pt") return pt_macro_carbs(inputs)
	if (locale === "ja") return ja_macro_carbs(inputs)
	return zh_macro_carbs(inputs)
};